module.exports = ".cursor-pointer {\n    cursor: pointer;\n}\n.advanced-search {\n    border-bottom: 1px solid #edf0f4;\n    margin: -0.5em 1.5em 1em 0;\n    padding-bottom: 1em;\n}"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/viagens/deslocamentos/deslocamento-list/deslocamento-list.component.css
 ** module id = 646
 ** module chunks = 0
 **/